<template>
  <div :key="percentage" ref="bar" class="percentage-bar" :style="{ width: `${(lineWidth / 1920) * 100}vw` }">
    <div class="bar-inner" :style="barStyle"></div>
    <div class="dot" :style="{ backgroundColor: color, ...dotStyle }"></div>
  </div>
</template>

<script>
export default {
  props: {
    lineWidth: {
      type: Number,
      default: 431,
    },
    percentage: {
      type: Number,
      default: 0,
    },
    // 动画持续时间
    duration: {
      type: Number,
      default: 800,
    },
    // 光圈颜色
    apertureColor: {
      type: String,
      default: 'rgba(30, 175, 244, 0.4706)',
    },
    // 圆点颜色
    color: {
      type: String,
      default: '#0FA2FD',
    },
  },
  data() {
    return {
      barStyle: { borderRight: '' },
      dotStyle: { left: '' },
      clientWidth: 0,
    }
  },
  watch: {
    percentage: {
      immediate: true,
      handler(val) {
        this.init()
      },
    },
  },
  created() {
    this.dotStyle = {
      transform: 'scale(0) translateY(-50%)',
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.clientWidth = this.$refs.bar.clientWidth
        setTimeout(() => {
          this.barStyle = {
            borderRight: `${((this.percentage * this.lineWidth) / 1920) * 100}vw solid ${this.color}`,
            transition: `border ${this.duration}ms ease-in-out`,
          }
        }, 0)
        setTimeout(() => {
          this.dotStyle = {
            left: `${((this.percentage * (this.lineWidth - 2)) / 1920) * 100}vw`,
            transform: 'scale(1) translateY(-50%)',
            transition: `transform ${this.duration}ms ease-in-out`,
          }
        }, this.duration / 2)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/charts.scss';
.percentage-bar {
  height: vh(4);
  border-radius: vh(7);
  background: linear-gradient(270deg, rgba(255, 255, 255, 0.1) 11%, rgba(255, 255, 255, 0) 100%);
  position: relative;
}

.bar-inner {
  border-radius: vh(16);
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 0;
  height: 0;
  border: vh(2) solid transparent;
}

.dot {
  width: vh(6);
  height: vh(6);
  border-radius: 50%;
  position: absolute;
  top: 50%; /* 中心对齐 */
}

.dot::before {
  content: '';
  display: block;
  width: vh(16);
  height: vh(16);
  box-shadow: inset 0px 0px 5px 0px rgba(30, 175, 244, 0.4706);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}
</style>
